/**
 * @generated SignedSource<<cdedef1245b75d34c6f05973ccf38abe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type expenseRow_project$data = {
  readonly id: string;
  readonly budgetType: BUDGET_TYPE | null;
  readonly companyProjectId: number | null;
  readonly " $fragmentType": "expenseRow_project";
};
export type expenseRow_project$key = {
  readonly " $data"?: expenseRow_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"expenseRow_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "expenseRow_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "2d4772e76bffab6372915dd4626e5a06";

export default node;
